import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";

import PublicLayout from "@/components/PublicLayout";
import PublicPage from "@/pages/PublicPage";
import BlogPostPage from "@/pages/BlogPostPage";
import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/components/AuthCallback";

import AdminLayout from "@/components/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminPages from "@/pages/admin/AdminPages";
import AdminPageEditor from "@/pages/admin/AdminPageEditor";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminBlogEditor from "@/pages/admin/AdminBlogEditor";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminInbox from "@/pages/admin/AdminInbox";
import AdminAdmins from "@/pages/admin/AdminAdmins";
import AdminSettings from "@/pages/admin/AdminSettings";
import FloatingCallButton from "@/components/FloatingCallButton";

function AppRoutes() {
  const location = useLocation();
  // Synchronous: detect session_id in URL fragment BEFORE rendering normal routes
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const isAdminRoute = location.pathname.startsWith("/admin") || location.pathname.startsWith("/login") || location.pathname.startsWith("/auth");
  return (
    <>
      <Routes>
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/login" element={<LoginPage />} />

        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="pages" element={<AdminPages />} />
          <Route path="pages/:pageId" element={<AdminPageEditor />} />
          <Route path="blog" element={<AdminBlog />} />
          <Route path="blog/:postId" element={<AdminBlogEditor />} />
          <Route path="media" element={<AdminMedia />} />
          <Route path="inbox" element={<AdminInbox />} />
          <Route path="admins" element={<AdminAdmins />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>

        <Route path="/" element={<PublicLayout />}>
          <Route index element={<PublicPage />} />
          <Route path="blog/:slug" element={<BlogPostPage />} />
          <Route path=":slug" element={<PublicPage />} />
        </Route>
      </Routes>
      {!isAdminRoute && <FloatingCallButton />}
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppRoutes />
            <Toaster position="top-right" />
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}
